import React, { useState, useEffect } from 'react';
import {
  HeaderList,
  ImgContainer,
  List,
  SectionContainer,
  Title,
  VideoList,
  VideoTitle,
} from './styles';
import ReactPlayer from 'react-player';
import Tooltip from '@mui/material/Tooltip';
import ClassRoomItems from 'components/layout/ClassroomItems';
import { Box, Button, Typography, Paper } from '@mui/material';
import { fetchWithToken } from 'helpers/fetch';
import { endPoints } from 'const/endPoints';
import Toast from 'components/common/Popup/Toast';
import DownloadIcon from '@mui/icons-material/Download';
import Stack from '@mui/material/Stack';
import DescriptionIcon from '@mui/icons-material/Description';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { truncate } from "helpers/truncate";
import { Lessons } from 'components/layout/CourseTab/Lessons';
import { styled, useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import parse from 'html-react-parser'
import { useSelector } from 'react-redux';
import PopupError from '../../../components/common/Popup/PopupError';
var FileSaver = require('file-saver');

const drawerWidth = {
  width: '85%',
  maxWidth: '400px',
  '@media (min-width:600px)': {
    width: '75%'
  },
  '@media (min-width:900px)': {
    width: '50%'
  },
  '@media (min-width:1200px)': {
    width: '40%'
  }
}
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: 0,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: 0,

    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: 0
    })
  })
);


const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end"
}));

export const VideoLesson = ({
  lesson,
  lessonsAndQuizzes,
  date,
  cleanTitle,
  lessonId,
  section,
  course,
  resources
}) => {

  const [currentLink, setCurrentLink] = useState('')
  const [links, setLinks] = useState([])
  const [header, setHeader] = useState('video')
  const [isPay, setIsPay] = useState(false);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  
  const { user } = useSelector(state => state.auth);

  const handleDrawerOpen = () => {
    setOpen(true); 
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    const checkPayment = async () => {
      const res = await fetchWithToken(
        `${endPoints.check_payment}/${course.id}`
      );

      const isPay = await res.json();
      if (res.status === 401) {
        setIsPay(false);
        return;
      }
      setIsPay(isPay);
    };
    checkPayment();
  }, []);



  useEffect(() => {
    const fetchVideoData = async () => {
      setCurrentLink('')
      setLinks([])
      const resp = await fetchWithToken(`${endPoints.get_video_by_lesson}/${lessonId}`)
      const data = await resp.json();
      console.log(data.links)
      for (let i = 0; i < 5; i++) {
        if (data.links[i].url !== '') {
          setCurrentLink(data.links[i])
          i = 5 
        }
      }
      setLinks(data.links)
      console.log(data)
    }
    fetchVideoData();
  }, [lessonId])
  const handleResource = async (item) => {
    FileSaver.saveAs(item.path, item.filename)
    Toast('success', "Resource Downloaded successfully");
  }

  const handleResolution = (index) => {
    setCurrentLink(links[index])
  }
  // const firstNextLesson = nextSection[0];
  // const newType = type === 'clase' ? 'clase' : 'quiz';

  // const nextPath =
  //   firstNextLesson &&
  //   `/course/classroom/${cleanTitle}/${newType}/${firstNextLesson.id}`;
  
  // Verificar si el usuario está inactivo cuando intenta acceder al contenido
  useEffect(() => {
    if (user && user.isActive === false) {
      PopupError("Tu usuario está inactivo. Para reactivar tu cuenta, realiza el pago correspondiente y comunícate con nosotros al correo cenaoz.docencia@gmail.com");
      window.location.href = '/access';
    }
  }, [user]);
  
  return (
    <>
      <Box sx={{ display: "flex", position: "relative" }}>
        <CssBaseline />
        <Tooltip 
          title="Contenido del Curso" 
          placement="right"
          sx={{
            "& .MuiTooltip-tooltip": {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              backdropFilter: "blur(10px)",
              fontSize: "12px",
              fontWeight: 500,
              padding: "8px 12px",
              borderRadius: "8px",
            }
          }}
        >
          <IconButton
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ 
              position: "fixed",
              top: { xs: 70, sm: 80, md: 90 },
              left: { xs: 16, sm: 20, md: 24 },
              zIndex: 1300,
              width: { xs: 48, sm: 52 },
              height: { xs: 48, sm: 52 },
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              border: "1px solid rgba(0, 0, 0, 0.08)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)",
              borderRadius: "16px",
              color: "#5866ad",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "@media (max-width: 600px)": {
                top: 70,
                left: 12,
                width: 44,
                height: 44,
                borderRadius: "12px",
              },
              "&:hover": {
                backgroundColor: "rgba(88, 102, 173, 0.1)",
                transform: "scale(1.05) translateY(-2px)",
                boxShadow: "0 12px 40px rgba(88, 102, 173, 0.25), 0 4px 12px rgba(0, 0, 0, 0.15)",
                color: "#4a5a9d",
              },
              "&:active": {
                transform: "scale(0.95)",
                transition: "all 0.1s ease",
              },
              ...(open && { 
                opacity: 0,
                transform: "scale(0.8) translateX(-100px)",
                pointerEvents: "none",
              })
            }}
          >
            <MenuIcon 
              sx={{ 
                fontSize: { xs: 20, sm: 24 },
                transition: "all 0.2s ease",
              }} 
            />
          </IconButton>
        </Tooltip>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              background: "linear-gradient(180deg, rgba(248, 249, 250, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              borderRight: "1px solid rgba(88, 102, 173, 0.12)",
              boxShadow: "4px 0 24px rgba(0, 0, 0, 0.08), 2px 0 8px rgba(88, 102, 173, 0.05)",
            },
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
            }
          }}
          onBackdropClick={handleDrawerClose}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader 
            sx={{
              background: "linear-gradient(135deg, rgba(88, 102, 173, 0.08) 0%, rgba(255, 255, 255, 0.95) 100%)",
              backdropFilter: "blur(10px)",
              borderBottom: "1px solid rgba(88, 102, 173, 0.15)",
              minHeight: 72,
              px: 3,
              py: 2,
              "@media (max-width: 600px)": {
                minHeight: 64,
                px: 2,
                py: 1.5,
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
              <Box 
                sx={{ 
                  display: "flex", 
                  alignItems: "center", 
                  gap: 2, 
                  flex: 1 
                }}
              >
                <Box 
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "12px",
                    background: "linear-gradient(135deg, #5866ad 0%, #37b0cf 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(88, 102, 173, 0.3)",
                  }}
                >
                  <OndemandVideoIcon 
                    sx={{ 
                      color: "white", 
                      fontSize: 20 
                    }} 
                  />
                </Box>
                <Box>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      fontWeight: 700,
                      fontSize: "18px",
                      background: "linear-gradient(135deg, #5866ad 0%, #37b0cf 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      lineHeight: 1.2,
                      mb: 0.5,
                      "@media (max-width: 600px)": {
                        fontSize: "16px",
                      },
                    }}
                  >
                    Contenido del Curso
                  </Typography>
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: "#666",
                      fontSize: "12px",
                      fontWeight: 500,
                    }}
                  >
                    Navega por las lecciones
                  </Typography>
                </Box>
              </Box>
              <IconButton 
                onClick={handleDrawerClose}
                sx={{
                  width: 36,
                  height: 36,
                  backgroundColor: "rgba(88, 102, 173, 0.1)",
                  color: "#5866ad",
                  borderRadius: "10px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "rgba(88, 102, 173, 0.15)",
                    transform: "scale(1.05)",
                    color: "#4a5a9d",
                  },
                  "&:active": {
                    transform: "scale(0.95)",
                  }
                }}
              >
                {theme.direction === "ltr" ? (
                  <ChevronLeftIcon sx={{ fontSize: 20 }} />
                ) : (
                  <ChevronRightIcon sx={{ fontSize: 20 }} />
                )}
              </IconButton>
            </Box>
          </DrawerHeader>
          
          <Box 
            sx={{
              padding: "20px 24px",
              margin: "16px 20px 24px 20px",
              borderRadius: "16px",
              background: "linear-gradient(135deg, rgba(88, 102, 173, 0.08) 0%, rgba(255, 255, 255, 0.95) 100%)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              border: "1px solid rgba(88, 102, 173, 0.12)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(88, 102, 173, 0.08)",
              transition: "all 0.2s ease",
              "@media (max-width: 600px)": {
                padding: "16px 16px",
                margin: "12px 12px 20px 12px",
                borderRadius: "12px",
              },
            }}
          >
            <Typography 
              variant="subtitle1" 
              sx={{ 
                fontWeight: 700,
                fontSize: "1.1rem",
                color: "#5866ad",
                textAlign: "center",
                letterSpacing: "0.5px",
                lineHeight: 1.3,
                "@media (max-width: 600px)": {
                  fontSize: "1rem",
                },
              }}
            >
              {section.name}
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: "#666",
                textAlign: "center",
                mt: 0.5,
                fontSize: "0.85rem",
                fontWeight: 500,
                "@media (max-width: 600px)": {
                  fontSize: "0.8rem",
                },
              }}
            >
              Sección actual
            </Typography>
          </Box>

          <Box sx={{ flex: 1, overflow: "auto" }}>
            <Lessons
              courseId={course.id}
              courseTitle={course.title}
              isPay={isPay}
              current={section}
              handleDrawerClose={handleDrawerClose}
              fromDrawer={true}
              slice={true}
            />
          </Box>
        </Drawer>
        <Main 
          open={open}
          sx={{
            paddingLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            "@media (max-width: 600px)": {
              marginLeft: 0,
            }
          }}
        >
          <DrawerHeader />
        </Main>
      </Box>
      <Box
        sx={{
          height: 'calc(100vh - 84px)',
          backgroundColor: ' #f8f8f8',
        }}
      >
        <SectionContainer>
          <ImgContainer>
            <ReactPlayer
              url={currentLink.url}
              width="100%"
              height="100%"
              controls
              playing
              style={{
                // make minimalistic player
                objectFit: 'fill',
                objectPosition: 'cenfter',
                backgroundColor: '#0f0f0f',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                border: 'none',
              }}
              config={{
                file: {
                  attributes: {
                    autoPlay: false,
                    controlsList: 'nodownload'
                  },
                },
              }}
            />
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop="10px"
            >
              {
                links.map((link, index) => {
                  return <Button key={index} variant='contained' size="medium" disabled={link.url == ''} color={currentLink.name === link.name ? "success" : "primary"}
                    onClick={() => handleResolution(index)}>{link.name} px
                  </Button>
                })
              }
            </Stack>
            <VideoTitle>
              <h1>{lesson.name}</h1>
              <h2>{date}</h2>
              <h3>{parse(lesson.description)}</h3>
            </VideoTitle>
          </ImgContainer>
          <VideoList>
            <HeaderList>
              <Title>
                <h1>{section.name}</h1>
              </Title>
              <Box 
                sx={{
                  display: 'flex',
                  borderTop: '1px solid rgba(255,255,255,0.3)',
                }}
              >
                <Button
                  sx={{
                    flex: 1,
                    color: '#fff',
                    borderRadius: 0,
                    padding: '12px',
                    backgroundColor: header === 'video' ? 'rgba(255,255,255,0.2)' : 'transparent',
                    borderRight: '1px solid rgba(255,255,255,0.3)',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                    }
                  }}
                  onClick={() => setHeader('video')}
                >
                  <OndemandVideoIcon sx={{ mr: 1, fontSize: 18 }} />
                  Videos y Lecciones
                </Button>
                <Button
                  sx={{
                    flex: 1,
                    color: '#fff',
                    borderRadius: 0,
                    padding: '12px',
                    backgroundColor: header === 'resource' ? 'rgba(255,255,255,0.2)' : 'transparent',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.1)',
                    }
                  }}
                  onClick={() => setHeader('resource')}
                >
                  <DescriptionIcon sx={{ mr: 1, fontSize: 18 }} />
                  Recursos
                </Button>
              </Box>
            </HeaderList>
            {header === 'video' ? <List>
              {lessonsAndQuizzes.map((item, index) => {
                const lessonType = item.status ? 'quiz' : 'clase';
                return (
                  <ClassRoomItems
                    key={index}
                    type={lessonType}
                    courseTitle={cleanTitle}
                    lessonId={lessonId}
                    item={item}
                  />
                );
              })}
            </List> :
              <List>
                {resources.length > 0 ? (
                  <Box sx={{ padding: '8px' }}>
                    {resources.map((item, index) => (
                      <Paper
                        key={index}
                        elevation={1}
                        sx={{
                          margin: "8px",
                          padding: "12px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: 3,
                            backgroundColor: "#f5f5f5",
                          },
                        }}
                        onClick={() => handleResource(item)}
                      >
                        <Stack 
                          direction="row" 
                          alignItems="center" 
                          spacing={2}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                              backgroundColor: "rgba(25,118,210,0.1)",
                            }}
                          >
                            <DescriptionIcon 
                              sx={{ 
                                fontSize: 20, 
                                color: "#1976d2" 
                              }} 
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography 
                              variant="body2" 
                              sx={{ 
                                fontWeight: 500,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.filename}
                            </Typography>
                            <Typography 
                              variant="caption" 
                              sx={{ 
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <DownloadIcon sx={{ fontSize: 14 }} />
                              Hacer clic para descargar
                            </Typography>
                          </Box>
                        </Stack>
                      </Paper>
                    ))}
                  </Box>
                ) : (
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '200px',
                      color: '#666',
                      textAlign: 'center',
                      padding: '20px',
                    }}
                  >
                    <DescriptionIcon 
                      sx={{ 
                        fontSize: 48, 
                        color: '#ccc',
                        marginBottom: 2,
                      }} 
                    />
                    <Typography variant="body1" sx={{ color: '#999' }}>
                      No hay recursos disponibles
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#ccc' }}>
                      Los recursos aparecerán aquí cuando estén disponibles
                    </Typography>
                  </Box>
                )}
              </List>
            }
          </VideoList>
        </SectionContainer>
      </Box >
    </>

  );
};
